import React, { useEffect } from 'react';
import settingServiceActions from 'features/settingService/services/actions';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import SuppliersSettingFilter from './components/SuppliersSettingFilter';
import SuppliersSettingTable from './components/SuppliersSettingTable';

const SuppliersSetting = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      settingServiceActions.setSuppliersSettingParams({
        page: 1,
        keySearch: '',
      })
    );
  }, []);
  return (
    <Container>
      <Content>
        <SuppliersSettingFilter />
        <SuppliersSettingTable />
      </Content>
    </Container>
  );
};

export default SuppliersSetting;

const Container = styled.div`
  padding: 16px;
`;

const Content = styled.div`
  padding: 16px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
